import { createContext, useState, useCallback } from "react";
import { Snackbar, Alert } from "@mui/material";

export const SnackbarContext = createContext();

const AppSnackbar = ({ children }) => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const showSnackbar = useCallback(
        (message, severity = "success") => {
            setSnackbar({
                open: true,
                message,
                severity,
            });
        },
        []
    );

    const handleClose = (event, reason) => {
        if (reason === "clickaway") return;

        setSnackbar((prev) => ({
            ...prev,
            open: false,
        }));
    };

    return (
        <SnackbarContext.Provider value={{ showSnackbar }}>
            {children}

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={handleClose}
                    severity={snackbar.severity}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </SnackbarContext.Provider>
    );
};

export default AppSnackbar;